<template>
  <b-col sm="12" md="3" class="h-100">
    <b-overlay class="h-100" :show="show">
      <b-card :body-class="['d-flex flex-column', textAlign]" class="card-responsive h-100">
        <b-card-title>
          <div class="mb-3 d-flex">
            {{ add ? t('Add patient') : t('Sign up') }}
          </div>

          <auth-nav v-if="!add"></auth-nav>
        </b-card-title>

        <div class="d-inline-flex align-items-center py-3">
          <b-form-checkbox
              v-model="subAccount"
          >
            {{ t('Add sub account') }}
          </b-form-checkbox>

          <b-icon-question class="text-info border rounded border-skyler mx-1" v-b-tooltip
                           :title="t('Allows you to create an account for the people you are responsible for (children, parents)')"></b-icon-question>
        </div>

        <form-wizard transition="fade" class="pb-0" ref="wizardSubAccount" color="#9AB5FF" step-size="xs"
                     title=""
                     subtitle="" v-show="subAccount">
          <custom-wizard-step
              slot-scope="props"
              slot="step"
              :tab="props.tab"
              :transition="props.transition"
              :index="props.index">
          </custom-wizard-step>

          <tab-content icon="i-person-filled">
            <div class="d-flex flex-column justify-content-around py-3">
              <h4 class="d-flex">{{ t('Personal Info') }}</h4>
              <small class="text-muted d-flex">{{ t('Personal Info') }}</small>
            </div>

            <b-form @submit.prevent="next" id="personal-info-w-sub">
              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="personal_info.first_name" required
                                name="first_name"
                                :placeholder="t('First name') + ' *'"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="personal_info.father_name" required
                                name="father_name"
                                :placeholder="t('Father name') + ' *'"
                                type="text"></b-form-input>

                  <div class="mx-1"></div>

                  <b-form-input size="sm" v-model="personal_info.mother_name" required
                                name="mother_name"
                                :placeholder="t('Mother name') + ' *'"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="personal_info.last_name" required name="last_name"
                                :placeholder="t('Last name') + ' *'"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group
                  :description="t('To send you your EHR\'s serial number and password')">

                <b-input-group>
                  <vue-country-code
                      style="height: 31px;"
                      @onSelect="onPersonalCountrySelect"
                      :enableSearchField = true
                      :enabledCountryCode = true
                      :disabledFetchingCountry = true
                      :onlyCountries="['sy']">
                  </vue-country-code>
                  <input type="tel" class="form-control form-control-sm" required name="mobile"
                         :placeholder="t('Mobile number') + ' *'" v-model="personal_info.mobile">
                </b-input-group>

              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="personal_info.identity_number_type"
                            :required="!subAccount || (personal_info.identity_number)"
                            name="identity_type">
                    <option :value="null" disabled>{{ t('ID type') }} *</option>
                    <option v-for="(id, name) in IDENTITY_TYPES[$translate.lang]"
                            :value="id">
                      {{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group
                  :description="t('To avoid duplication of EHR\'S with another patient')">
                <b-input-group>
                  <input class="form-control form-control-sm"
                         type="text"
                         name="identity_number"
                         v-model="personal_info.identity_number"
                         :required="!subAccount || (personal_info.identity_number_type)"
                         :placeholder="(typeof t('ID number') === 'object' ? (t('ID number')[personal_info.identity_number_type] || '') : t('ID number')) + ' *'">
                </b-input-group>
              </b-form-group>
            </b-form>
          </tab-content>

          <tab-content icon="i-person-filled">
            <div class="d-flex flex-column justify-content-around py-3">
              <h4 class="d-flex">{{ t('Sub account') }}</h4>
              <small class="text-muted d-flex">{{
                  t('Allows you to create an account for the people you are responsible for (children, parents)')
                }}
                <br>
                {{
                  t('Please enter your personal info as an account responsible')
                }}
              </small>
            </div>

            <b-form @submit.prevent="next" id="sub-account">
              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="sub_account.name"
                                name="full_name"
                                :placeholder="t('Full name') + ' *'" type="text"
                                required></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <vue-country-code
                      style="height: 31px;"
                      @onSelect="onSubCountrySelect"
                      :enableSearchField = true
                      :enabledCountryCode = true
                      :disabledFetchingCountry = true
                      :onlyCountries="['sy']">
                  </vue-country-code>
                  <b-form-input size="sm" v-model="sub_account.phone"
                                no-wheel
                                name="mobile"
                                :placeholder="t('Mobile number') + ' *'"
                                type="tel" required></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="sub_account.relationship"
                            required name="kind_of_relationship">
                    <option :value="null" disabled>{{ t('Kind of relationship') }} *</option>
                    <option v-for="(id, name) in KIND_OF_RELATIONSHIPS[$translate.lang]"
                            :value="id">{{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="sub_account.identity_number_type"
                            required>
                    <option :value="null" disabled>{{ t('ID type') }}</option>
                    <option v-for="(id, name) in IDENTITY_TYPES[$translate.lang]" :value="id">
                      {{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group :description="t('To avoid duplication of EHR\'S with another patient')">
                <b-input-group>
                  <input class="form-control form-control-sm"
                         type="text"
                         name="identity_number"
                         v-model="sub_account.identity_number"
                         required
                         :placeholder="typeof t('ID number') === 'object' ? (t('ID number')[sub_account.identity_number_type] || '') : t('ID number')">
                </b-input-group>
              </b-form-group>
            </b-form>
          </tab-content>

          <tab-content icon="i-info">
            <div class="d-flex flex-column justify-content-around py-3">
              <h4 class="d-flex">{{ t('Residence Info') }}</h4>
              <small class="text-muted d-flex">{{ t('Residence Info') }}</small>
            </div>

            <b-form @submit.prevent="next" id="residence-info-w-sub">
              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="residence_info.gender" required>
                    <option :value="null" disabled>{{ t('Gender') }} *</option>
                    <option v-for="(id, name) in GENDERS[$translate.lang]" :value="id">{{ name }}
                    </option>
                  </b-select>

                  <div class="mx-1"></div>

                  <b-select size="sm" v-model="residence_info.nationality" id= "residence_info_sub_nationality">
                    <option :value="null" disabled>{{ t('Nationality') }}</option>
                    <option v-for="nationality in prefaredNationalities" :value="nationality.id" :country_code="nationality.country_code">
                      {{ nationality[nameKey] }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="year" required>
                    <b-select-option :value="null" disabled>{{ t('Year') }} *</b-select-option>
                    <b-select-option v-for="year in YEARS" :value="year" :key="year">
                      {{ year }}
                    </b-select-option>
                  </b-select>

                  <b-select class="mx-2" size="sm" v-model="month" required>
                    <b-select-option :value="null" disabled>{{ t('Month') }} *</b-select-option>
                    <b-select-option v-for="month in MONTHS" :value="month" :key="month">
                      {{ month }}
                    </b-select-option>
                  </b-select>

                  <b-select size="sm" v-model="day" required>
                    <b-select-option :value="null" disabled>{{ t('Day') }} *</b-select-option>
                    <b-select-option v-for="day in DAYS" :value="day" :key="day">
                      {{ day }}
                    </b-select-option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="residence_info.marital_status">
                    <option :value="null" disabled>{{ t('Marital status') }}</option>
                    <option v-for="(id,name) in MARITAL_STATUS[$translate.lang]" :value="id">
                      {{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <v-select v-model="residence_info.area_id" :placeholder="t('Area') + ' *'"
                            dir="auto"
                            :options="AREAS" :label="nameKey"
                            :reduce="area => area.id">
                    <template v-slot:search="{attributes, events}">
                      <input
                          class="vs__search"
                          :required="!residence_info.area_id"
                          v-bind="attributes"
                          v-on="events"
                      />
                    </template>
                  </v-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="residence_info.address" name="address"
                                :placeholder="t('Address')"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </tab-content>

          <tab-content icon="i-alarm">
            <div class="d-flex flex-column justify-content-around py-3">
              <h4 class="d-flex">{{ t('ER Profile') }}</h4>
              <small class="text-muted d-flex">{{
                  t('Please enter the personal info of someone of a close person to contact in case of emergency')
                }}</small>
            </div>

            <b-form @submit.prevent="submit" id="er-profile-w-sub">
              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" required v-model="er_profile.first_name" name="first_name"
                                :placeholder="t('First name') + ' *'" type="text"></b-form-input>

                  <div class="mx-1"></div>

                  <b-form-input size="sm" required v-model="er_profile.last_name" name="last_name"
                                :placeholder="t('Last name') + ' *'" type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <vue-country-code
                      style="height: 31px;"
                      @onSelect="onErCountrySelect"
                      :enableSearchField = true
                      :enabledCountryCode = true
                      :disabledFetchingCountry = true
                      :onlyCountries="['sy']">
                  </vue-country-code>
                  <b-form-input size="sm" no-wheel required v-model="er_profile.mobile" name="mobile"
                                :placeholder="t('Mobile number') + ' *'" type="tel"></b-form-input>

                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="er_profile.gender" required>
                    <option :value="null" disabled selected>{{ t('Gender') }} *</option>
                    <option v-for="(id, name) in GENDERS[$translate.lang]" :value="id">{{ name }}
                    </option>
                  </b-select>

                  <div class="mx-1"></div>

                  <b-select size="sm" v-model="er_profile.relationship" required>
                    <option :value="null" disabled selected>{{ t('Kind of relationship') }} *</option>
                    <option v-for="(id, name) in KIND_OF_RELATIONSHIPS[$translate.lang]"
                            :value="id">{{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>
            </b-form>
          </tab-content>

          <template v-slot:footer="{prevTab ,isLastStep, activeTabIndex}">
            <div class="d-flex justify-content-around">
              <b-button class="px-4" size="sm" pill variant="secondary" v-if="activeTabIndex > 0"
                        @click="prevTab()">{{ t('Previous') }}
              </b-button>

              <b-button class="px-4" size="sm" pill variant="outline-primary" :to="{name: 'login'}"
                        v-else-if="!add">
                <i-back class="pb-1" height="1em" width="1em"></i-back>
                {{ t('Login') }}
              </b-button>

              <b-button class="px-4" size="sm" type="submit" :form="formId(activeTabIndex)" pill
                        variant="primary">
                {{ isLastStep ? t('Done') : t('Next') }}
              </b-button>
            </div>
          </template>
        </form-wizard>

        <form-wizard transition="fade" class="pb-0" ref="wizard" color="#9AB5FF" step-size="xs" title=""
                     subtitle="" v-show="!subAccount">
          <custom-wizard-step
              slot-scope="props"
              slot="step"
              :tab="props.tab"
              :transition="props.transition"
              :index="props.index">
          </custom-wizard-step>

          <tab-content icon="i-person-filled">
            <div class="d-flex flex-column justify-content-around py-3">
              <h4 class="d-flex">{{ t('Personal Info') }}</h4>
              <small class="text-muted d-flex">{{ t('Personal Info') }}</small>
            </div>

            <b-form @submit.prevent="next" id="personal-info">
              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="personal_info.first_name" required
                                name="first_name"
                                :placeholder="t('First name') + ' *'"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="personal_info.father_name" required
                                name="father_name"
                                :placeholder="t('Father name') + ' *'"
                                type="text"></b-form-input>

                  <div class="mx-1"></div>

                  <b-form-input size="sm" v-model="personal_info.mother_name" required
                                name="mother_name"
                                :placeholder="t('Mother name') + ' *'"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="personal_info.last_name" required name="last_name"
                                :placeholder="t('Last name') + ' *'"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group
                  :description="t('To send you your EHR\'s serial number and password')">
                <b-input-group>
                  <vue-country-code
                      style="height: 31px;"
                      @onSelect="onPersonalCountrySelect"
                      :enableSearchField = true
                      :enabledCountryCode = true
                      :disabledFetchingCountry = true
                      :onlyCountries="['sy']">
                  </vue-country-code>
                  <input type="tel" class="form-control form-control-sm" required name="mobile"
                         :placeholder="t('Mobile number') + ' *'" v-model="personal_info.mobile">
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="personal_info.identity_number_type"
                            required
                            name="identity_type">
                    <option :value="null" disabled>{{ t('ID type') }} *</option>
                    <option v-for="(id, name) in IDENTITY_TYPES[$translate.lang]"
                            :value="id">
                      {{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group
                  :description="t('To avoid duplication of EHR\'S with another patient')">
                <b-input-group>
                  <input class="form-control form-control-sm"
                         type="text"
                         name="identity_number"
                         v-model="personal_info.identity_number"
                         :required="!subAccount || (personal_info.identity_number_type)"
                         :placeholder="(typeof t('ID number') === 'object' ? (t('ID number')[personal_info.identity_number_type] || '') : t('ID number')) + ' *'">
                </b-input-group>
              </b-form-group>
            </b-form>
          </tab-content>

          <tab-content icon="i-info">
            <div class="d-flex flex-column justify-content-around py-3">
              <h4 class="d-flex">{{ t('Residence Info') }}</h4>
              <small class="text-muted d-flex">{{ t('Residence Info') }}</small>
            </div>

            <b-form @submit.prevent="next" id="residence-info">
              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="residence_info.gender" required>
                    <option :value="null" disabled>{{ t('Gender') }} *</option>
                    <option v-for="(id, name) in GENDERS[$translate.lang]" :value="id">{{ name }}
                    </option>
                  </b-select>

                  <div class="mx-1"></div>

                  <b-select size="sm" v-model="residence_info.nationality" id="residence_info_nationality">
                    <option :value="null" disabled>{{ t('Nationality') }}</option>
                    <option v-for="nationality in prefaredNationalities" :value="nationality.id" :country_code="nationality.country_code">
                      {{ nationality[nameKey] }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="year" required>
                    <b-select-option :value="null" disabled>{{ t('Year') }} *</b-select-option>
                    <b-select-option v-for="year in YEARS" :value="year" :key="year">
                      {{ year }}
                    </b-select-option>
                  </b-select>

                  <b-select class="mx-2" size="sm" v-model="month" required>
                    <b-select-option :value="null" disabled>{{ t('Month') }} *</b-select-option>
                    <b-select-option v-for="month in MONTHS" :value="month" :key="month">
                      {{ month }}
                    </b-select-option>
                  </b-select>

                  <b-select size="sm" v-model="day" required>
                    <b-select-option :value="null" disabled>{{ t('Day') }} *</b-select-option>
                    <b-select-option v-for="day in DAYS" :value="day" :key="day">
                      {{ day }}
                    </b-select-option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="residence_info.marital_status">
                    <option :value="null" disabled>{{ t('Marital status') }}</option>
                    <option v-for="(id,name) in MARITAL_STATUS[$translate.lang]" :value="id">
                      {{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <v-select v-model="residence_info.area_id" :placeholder="t('Area') + ' *'"
                            :options="AREAS" :label="nameKey"
                            :reduce="area => area.id">
                    <template v-slot:search="{attributes, events}">
                      <input
                          class="vs__search"
                          :required="!residence_info.area_id"
                          v-bind="attributes"
                          v-on="events"
                      />
                    </template>
                  </v-select>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" v-model="residence_info.address" name="address"
                                :placeholder="t('Address')"
                                type="text"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </tab-content>

          <tab-content icon="i-alarm">
            <div class="d-flex flex-column justify-content-around py-3">
              <h4 class="d-flex">{{ t('ER Profile') }}</h4>
              <small class="text-muted d-flex">{{
                  t('Please enter the personal info of someone of a close person to contact in case of emergency')
                }}</small>
            </div>

            <b-form @submit.prevent="submit" id="er-profile">
              <b-form-group>
                <b-input-group>
                  <b-form-input size="sm" required v-model="er_profile.first_name" name="first_name"
                                :placeholder="t('First name') + ' *'" type="text"></b-form-input>

                  <div class="mx-1"></div>

                  <b-form-input size="sm" required v-model="er_profile.last_name" name="last_name"
                                :placeholder="t('Last name') + ' *'" type="text"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <vue-country-code
                      style="height: 31px;"
                      @onSelect="onErCountrySelect"
                      :enableSearchField = true
                      :enabledCountryCode = true
                      :disabledFetchingCountry = true
                      :onlyCountries="['sy']">
                  </vue-country-code>
                  <b-form-input size="sm" no-wheel required v-model="er_profile.mobile" name="mobile"
                                :placeholder="t('Mobile number') + ' *'" type="tel"></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group>
                <b-input-group>
                  <b-select size="sm" v-model="er_profile.gender" required>
                    <option :value="null" disabled selected>{{ t('Gender') }} *</option>
                    <option v-for="(id, name) in GENDERS[$translate.lang]" :value="id">{{ name }}
                    </option>
                  </b-select>

                  <div class="mx-1"></div>

                  <b-select size="sm" v-model="er_profile.relationship" required>
                    <option :value="null" disabled selected>{{ t('Kind of relationship') }} *</option>
                    <option v-for="(id, name) in KIND_OF_RELATIONSHIPS[$translate.lang]"
                            :value="id">{{ name }}
                    </option>
                  </b-select>
                </b-input-group>
              </b-form-group>
            </b-form>
          </tab-content>

          <template v-slot:footer="{prevTab ,isLastStep, activeTabIndex}">
            <div class="d-flex justify-content-around">
              <b-button class="px-4" size="sm" pill variant="secondary" v-if="activeTabIndex > 0"
                        @click="prevTab()">{{ t('Previous') }}
              </b-button>

              <b-button class="px-4" size="sm" pill variant="outline-primary" :to="{name: 'login'}"
                        v-else-if="!add">
                <i-back class="pb-1" height="1em" width="1em" stroke="#007bff"></i-back>
                {{ t('Login') }}
              </b-button>

              <b-button class="px-4" size="sm" type="submit" :form="formId(activeTabIndex)" pill
                        variant="primary">
                {{ isLastStep ? t('Done') : t('Next') }}
              </b-button>
            </div>
          </template>
        </form-wizard>
      </b-card>
    </b-overlay>
  </b-col>
</template>

<script>
import IBack from "../../components/Icons/IBack";
import CustomWizardStep from "../../components/Wizard/CustomWizardStep";
import AuthNav from "../../components/Navs/AuthNav";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'

export default {
  name: "SignUp",
  inject: ['patientRepo', 'dataRepo', 'dataOnlineRepo', 'patientOnlineRepo'],
  components: {CustomWizardStep, IBack, AuthNav, 'v-select': vSelect},
  computed: {
    DAYS() {
      if (this.month) {
        if (+this.month <= 7) {
          if (+this.month % 2 === 1) {
            return (new Array(31)).fill(0).map((_, i) => i + 1);
          } else {
            return (new Array(30)).fill(0).map((_, i) => i + 1);
          }
        } else {
          if (+this.month % 2 === 0) {
            return (new Array(31)).fill(0).map((_, i) => i + 1);
          } else {
            return (new Array(30)).fill(0).map((_, i) => i + 1);
          }
        }
      } else {
        return []
      }
    },
    textAlign() {
      return this.$translate.lang === 'en' ? 'text-left' : 'text-right'
    },
    nameKey() {
      return `name_${this.$translate.lang}`;
    }
  },
  data: () => ({
    sub_account: {identity_number_type: null, relationship: null},
    personal_info: {identity_number_type: null},
    er_profile: {gender: null, relationship: null},
    residence_info: {
      gender: null,
      nationality: null,
      marital_status: null,
      area_id: null
    },
    MARITAL_STATUS: [],
    GENDERS: [],
    KIND_OF_RELATIONSHIPS: [],
    NATIONALITIES: [],
    prefaredNationalities: [],
    AREAS: [],
    IDENTITY_TYPES: [],
    MONTHS: (new Array(12)).fill(0).map((_, i) => i + 1),
    YEARS: (new Array((new Date().getFullYear()) - 1930)).fill(0).map((_, i) => (1930 + i + 1)),
    month: null,
    day: null,
    year: null,
    show: true,
    subAccount: false,
    add: false,
  }),
  methods: {
    next() {
      this.subAccount ? this.$refs['wizardSubAccount'].nextTab() : this.$refs['wizard'].nextTab();
    },

    submit() {
      this.show = true;

      const repo = this.add ? this.patientOnlineRepo : this.patientRepo;

      this.residence_info.birthDate = `${this.year}-${this.month}-${this.day}`

      let nationality_select = document.getElementById('residence_info_nationality');
      let country_code = nationality_select.options[nationality_select.selectedIndex].getAttribute('country_code');
      this.residence_info.nationality_code = country_code;

      // add selected country code to the mobile numbers and send the country code with the payload
      this.personal_info = {...this.personal_info,
                            full_mobile : this.personal_info.dial_code + this.personal_info.mobile }

      this.sub_account = {...this.sub_account,
                            full_phone : this.sub_account.dial_code + this.sub_account.phone }

      this.er_profile = {...this.er_profile,
                            full_mobile : this.er_profile.dial_code + this.er_profile.mobile }

      repo.register({
        'personal_info': this.add ? {
          ...this.personal_info,
          added_by: localStorage.getItem('id')
        } : this.personal_info,
        'residence_info': this.residence_info,
        'sub_account': this.subAccount ? this.sub_account : {},
        'er_profile': this.er_profile,
        // 'selected_country': this.localStorageRepo.getCountryCode()
      })
          .then(({number}) => {
            return this.$swal.fire({
              icon: "success",
              text: this.t('A message has been sent to :number with your serial number and password').replace(':number', number),
            })
          })
          .then(() => {
            if (!this.add) {
              this.$router.push({name: 'login'})
            } else {
              if (this.$route.query.type === 'android') {
                AndroidFunction.click(1);
              } else if (this.$route.query.type === 'ios') {
                webkit.messageHandlers.callbackHandler.postMessage(1)
              }
            }
          })
          .catch(err => {
            this.$handleError(err)
            this.show = false;
          })
    },

    formId(activeTabIndex) {
      switch (activeTabIndex) {
        case 0: {
          return this.subAccount ? 'personal-info-w-sub' : 'personal-info';
        }

        case 1: {
          return this.subAccount ? 'sub-account' : 'residence-info';
        }

        case 2: {
          return this.subAccount ? 'residence-info-w-sub' : 'er-profile';
        }

        case 3: {
          return this.subAccount ? 'er-profile-w-sub' : 'er-profile';
        }
      }
    },

    onPersonalCountrySelect({name, iso2, dialCode}) {
      console.log(name, iso2, dialCode);
      this.personal_info = {...this.personal_info,
                            country_code:iso2,
                            dial_code: dialCode,
                           }
    },

    onSubCountrySelect({name, iso2, dialCode}) {
      // console.log(name, iso2, dialCode);
      this.sub_account = {...this.sub_account,
                          country_code:iso2,
                          dial_code: dialCode,
                         }
    },

    onErCountrySelect({name, iso2, dialCode}) {
      // console.log(name, iso2, dialCode);
      this.er_profile = {...this.er_profile,
                          country_code:iso2,
                          dial_code: dialCode,
                        }
    }

  },
  mounted() {
    this.add = this.$route.meta.addPatient || false;

    const repo = this.add ? this.dataOnlineRepo : this.dataRepo;

    repo.signUp().then(({data}) => {
      this.show = false
      this.GENDERS = data.genders
      this.MARITAL_STATUS = data.marital_status
      this.KIND_OF_RELATIONSHIPS = data.kind_of_relationships
      this.NATIONALITIES = data.countries
      this.prefaredNationalities = this.NATIONALITIES.filter(n => n.country_code == 'SY');
      this.AREAS = data.areas
      this.IDENTITY_TYPES = data.identity_types
    })

    if (this.$route.name === 'add-patient') {
      const lang = this.$route.query.lang || 'en';
      this.$translate.setLang(lang);
      document.querySelector('body').setAttribute("dir", lang === 'en' ? 'ltr' : 'rtl');
      document.querySelector('html').setAttribute("lang", lang);
    }
  }
}
</script>

<style scoped>

</style>
